import { createStore } from "vuex";

const store = createStore({
  state() {
    return {
      darkMode: false,
    };
  },

  mutations: {
    toggleDarkMode(state, val = null) {
      if (val !== null) {
        state.darkMode = val;
      } else {
        state.darkMode = !state.darkMode;
      }

      window.localStorage.setItem("ocdl-darkMode", state.darkMode);
      document.querySelector("html").classList.toggle("dark", state.darkMode);
    },

    setupDarkMode: (state) => {
      let darkMode = window.localStorage.getItem("ocdl-darkMode");

      if (darkMode === null) {
        darkMode =
          window.matchMedia &&
          window.matchMedia("(prefers-color-scheme: dark)").matches;
      } else {
        darkMode = darkMode === "true";
      }

      document.querySelector("html").classList.toggle("dark", darkMode);
      state.darkMode = darkMode;
    },
  },
});

export { store };
